function MapPoint(options) {
    this.lat = (options.lat) ? Number(options.lat) : 0;
    this.lng = (options.lng) ? Number(options.lng) : 0;
    this.zoom = (options.zoom) ? Number(options.zoom) : MapPoint.DEFAULT_ZOOM;
    this.icon = (options.icon) ? options.icon : MapPoint.MARKER_DEFAULT_IMAGE;
    this.iconWidth = (options.iconWidth) ? options.iconWidth : MapPoint.MARKER_DEFAULT_WIDTH;
    this.iconHeight = (options.iconHieght) ? options.iconHieght : MapPoint.MARKER_DEFAULT_HEIGHT;
    this.iconCenterX = (options.iconCenterX) ? options.iconCenterX : MapPoint.MARKER_DEFAULT_CENTERX;
    this.iconCenterY = (options.iconCenterY) ? options.iconCenterY : MapPoint.MARKER_DEFAULT_CENTERY;

    this.data = {};
    this.data.name = (options.name) ? options.name : null;
    this.data.address = (options.address) ? options.address : null;
    this.data.zipCode = (options.zipCode) ? options.zipCode : null;
    this.data.location = (options.location) ? options.location : null;
    this.data.province = (options.province) ? options.province : null;
    this.data.fax = (options.fax) ? options.fax : null;
    this.data.phone = (options.phone) ? options.phone : null;
    this.data.email = (options.email) ? options.email : null;
}

MapPoint.DEFAULT_ZOOM = MAP_ZOOM;
MapPoint.MARKER_DEFAULT_WIDTH = 42;
MapPoint.MARKER_DEFAULT_HEIGHT = 35;
MapPoint.MARKER_DEFAULT_CENTERX = 15;
MapPoint.MARKER_DEFAULT_CENTERY = 13;
MapPoint.MARKER_DEFAULT_IMAGE = '/img/icons/ico_googlemaps.png';
